/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlanDto } from '../../models/plan-dto';
import { UpdatePlanCommand } from '../../models/update-plan-command';

export interface ApiAdminBillingPlansCodePut$Params {
  code: string;
      body?: UpdatePlanCommand
}

export function apiAdminBillingPlansCodePut(http: HttpClient, rootUrl: string, params: ApiAdminBillingPlansCodePut$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBillingPlansCodePut.PATH, 'put');
  if (params) {
    rb.path('code', params.code, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlanDto>;
    })
  );
}

apiAdminBillingPlansCodePut.PATH = '/api/Admin/billing/plans/{code}';
